// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/pagination/pagination.component.scss
// module id = 433
// module chunks = 0